import * as firebase from 'firebase/app';
import "firebase/storage";
import "firebase/database";


const firebaseConfig = {
    apiKey: "AIzaSyDkGKW8Mn17bpfUi044WyI6L3F425vwdRs",
    authDomain: "thegana-7f09d.firebaseapp.com",
    databaseURL: "https://thegana-7f09d.firebaseio.com",
    projectId: "thegana-7f09d",
    storageBucket: "thegana-7f09d.appspot.com",
    messagingSenderId: "1058611984036",
    appId: "1:1058611984036:web:194d248d00897863a25831"
};

export const app = firebase.initializeApp(firebaseConfig);